export enum FormType {
  NotSet = 'NotSet',
  Question = 'question',
  Subscribe = 'subscribe',
  Tender = ' tender',
  Test = 'test',
  Response = 'response',
}
